import { z } from 'zod';
import { PERSON_NAME_MAX_LENGTH, PERSON_NAME_REGEX, personNameRegexMessage, safeTextSchema } from '@petseo/shared';

const TIME_REGEX = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/;

export const externalReservationSchema = z.object({
  employeeId: z.string().min(1, 'Pracownik jest wymagany'),
  serviceId: z.string().min(1, 'Usługa jest wymagana'),
  date: z.string().min(1, 'Data jest wymagana'),
  startTime: z.string().min(1, 'Godzina rozpoczęcia jest wymagana').regex(TIME_REGEX, 'Nieprawidłowy format godziny'),
  clientFirstName: z
    .string()
    .min(1, 'Imię klienta jest wymagane')
    .max(PERSON_NAME_MAX_LENGTH, `Imię może mieć maksymalnie ${PERSON_NAME_MAX_LENGTH} znaków`)
    .regex(PERSON_NAME_REGEX, personNameRegexMessage('Imię')),
  clientLastName: z
    .string()
    .min(1, 'Nazwisko klienta jest wymagane')
    .max(PERSON_NAME_MAX_LENGTH, `Nazwisko może mieć maksymalnie ${PERSON_NAME_MAX_LENGTH} znaków`)
    .regex(PERSON_NAME_REGEX, personNameRegexMessage('Nazwisko')),
  clientEmail: z
    .string()
    .min(1, 'Email klienta jest wymagany')
    .email('Nieprawidłowy format adresu e-mail')
    .max(255, 'Email może mieć maksymalnie 255 znaków'),
  clientPhone: z.string().min(1, 'Telefon klienta jest wymagany').max(20, 'Numer telefonu może mieć maksymalnie 20 znaków'),
  note: safeTextSchema('Notatka', { max: 500, required: false, multiline: true }).optional().or(z.literal('')),
});

export type ExternalReservationFormData = z.infer<typeof externalReservationSchema>;
